import React, {useEffect} from 'react';
import _ from 'lodash';
import {StateDictionary} from '../Models/AbroadPackageModels';
import {isMobile} from 'react-device-detect';
import '../Sass/AbroadStateInclude.scss';

interface AbroadStateIncludeProps {
  stateInclude: StateDictionary;
  fromFamily?: boolean;
}

const AbroadStateInclude = ({stateInclude, fromFamily}: AbroadStateIncludeProps) => {
  const StateRendering = () => {
    return _.toArray(stateInclude).map((value) => {
      return (
        <div className='abroadStateInclude__content__row' key={value}>
          <div className='abroadStateInclude__content__row__key'>{value[0]}</div>
          <div className='abroadStateInclude__content__row__value'>{value}</div>
        </div>
      );
    });
  };

  const ifFromFamilyClass = () => {
    if (fromFamily) return 'isFromFamily';
    else return '';
  };
  return (
    <div className={isMobile ? `abroadStateInclude isMobile ${ifFromFamilyClass()}` : `abroadStateInclude ${ifFromFamilyClass()}`}>
      <div className='abroadStateInclude__title'>מדינות כלולות</div>
      <div className='abroadStateInclude__content'>{StateRendering()}</div>
    </div>
  );
};

export default AbroadStateInclude;
